import React from 'react';

import LabeledStarRating from './LabeledStarRating';

export interface LabeledStarRatingsProps {
  ratings: Record<string, number>;
  color?: 'red' | 'gold';
}

export default function LabeledStarRatings(props: LabeledStarRatingsProps): JSX.Element {
  return (
    <>
      <div className="labeled-star-ratings-container">
        {Object.entries(props.ratings).map(([name, rating]) => (
          <LabeledStarRating color={props.color} label={name} rating={rating} />
        ))}
      </div>

      <style jsx>{`
        .labeled-star-ratings-container {
          display: flex;
          flex-direction: column;
          gap: 14px;
          white-space: nowrap;
        }
      `}</style>
    </>
  );
}
